// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import * as S from './styles';

const Select = ({ onChange, selectValue, children, withoutBorder, withBorder, disabled, size, defaultValue }, props) => (
  <S.SelectWrapper withoutBorder={withoutBorder} withBorder={withBorder} {...props}>
      <S.SelectStyled size={size} onChange={onChange} value={selectValue} defaultValue={defaultValue} disabled={disabled}>
          { children }
      </S.SelectStyled>
      <FontAwesomeIcon icon={faChevronDown} />
  </S.SelectWrapper>
)

Select.propTypes = {
    disabled: PropTypes.bool    
}

Select.defaultProps = {
    disabled: false
}

export default Select;